import { Swiper } from 'swiper';
import {
    Thumbs, Navigation, EffectFade,
} from 'swiper/modules';

Swiper.use([Thumbs, Navigation, EffectFade]);

const sectionSelector = '.about-page-history-section';
// eslint-disable-next-line no-unused-vars
const sectionCallBack = (sectionElement, query, queryAll) => {
    const carouselMain = query('.history-slider');
    const sliderLength = carouselMain.querySelectorAll('.swiper-slide').length;
    const carouselThumbs = query('.history-slider-thumbs');
    const swiperThumbs = new Swiper(carouselThumbs, {
        init: true,
        initialSlide: sliderLength,
        modules: [Thumbs],
        slidesPerView: 1,
        allowTouchMove: false,
        loop: true,
        breakpoints: {
            1025: {
                slidesPerView: 12,
            },
            1921: {
                slidesPerView: 13,
            },
        },
    });
    // eslint-disable-next-line no-unused-vars
    const swiperMain = new Swiper(carouselMain, {
        init: true,
        initialSlide: sliderLength,
        modules: [Thumbs, Navigation, EffectFade],
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup: 1,
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        thumbs: {
            swiper: swiperThumbs,
        },
        navigation: {
            prevEl: '.history-slider-button-prev',
            nextEl: '.history-slider-button-next',
        },
        loop: true,
        autoHeight: true,
    });
};

export { sectionSelector, sectionCallBack };
